module.exports = __webpack_public_path__ + "img/bag-icon.c1d15341.png";